import {StateResponse} from "../../features/state/models";
import {AppThunkAction} from "../../app/store";
import {AppStatusAction} from "../reducers/appStatus";
import * as types from '../constants/appStatus';

/**
 * Обновить статус приложения
 */
export const updateAppStatusFromState = (
  state: StateResponse,
  serverDate: string | null,
): AppThunkAction<AppStatusAction> =>
    dispatch =>
      dispatch({
        type: types.GET_APP_STATUS_FROM_STATE,
        payload: {
            state: state,
            serverDate: serverDate,
        },
      })

/**
 * Сбросить флаг необходимости принятия офферты
 */
export const clearNeedAcceptOffer = (): AppStatusAction => ({
  type: types.CLEAR_NEED_ACCEPT_OFFER,
})
